import { Box } from "@chakra-ui/layout";
import { Pricing } from "components";
import ProtectedRoute from "components/protected-route";
import { useSession } from "next-auth/react";
import React from "react";
import { Navbar } from "components/navbar";
import { CustomHead } from "components/custom-head";
import { Page } from "components/page";

export default (_props: any) => {
  const { data: session, status } = useSession() ?? {}
  const loading = status === "loading"



  if (!loading && !session) {
    return <ProtectedRoute />;
  }

  return (
    <Page forceCloseScheduler={true} >
      <Pricing />
    </Page>
  );
};
